import Vue from "vue";
import { BUILDER_USER_TYPE } from "../constants/custom-define-type";
import { mapActions } from 'vuex';

Vue.mixin({
    methods: {
        ...mapActions(['loadProfileBuilderList', 'reloadProfileBuilderList']),
        getListAllowReturningApplicantStatuses(profile) {
            const allowStatuses = this.tryGet(() => this.profile.additional_information
                .allow_returning_applicant_statuses);
            if (allowStatuses && allowStatuses.length) {
                return allowStatuses;
            }
            const applicationAbandonStatus =
                this.tryGet(
                    () => profile.additional_information.application_abandon_status
                ) || "Application Started";
            let result = ["Pre Application", applicationAbandonStatus];
            if (profile.user_type === BUILDER_USER_TYPE.CANDIDATE) {
                const candidateReapplicationStatuses =
                    this.$store.getters.candidateReapplicationStatuses;
                if (
                    candidateReapplicationStatuses &&
                    candidateReapplicationStatuses.length
                ) {
                    result = [...result, ...candidateReapplicationStatuses];
                }
            } else if (profile.user_type === BUILDER_USER_TYPE.CLIENT) {
                const clientReapplicationStatuses =
                    this.$store.getters.clientReapplicationStatuses;
                if (clientReapplicationStatuses && clientReapplicationStatuses.length) {
                    result = [...result, ...clientReapplicationStatuses];
                }
            }
            return this.deduplicateArray(result);
        }
    }
});


// WEBPACK FOOTER //
// ./src/mixins/builder-handling.js